/// <reference path="../../typings/index.d.ts" />
/// <reference path="apimodel.d.ts" />
/// <reference path="app.module.ts" />

((() => {
	'use strict';

	angular
		.module('app')
		.value('duScrollDuration', 400)
		.value('duScrollOffset', 0)
		.value('cgBusyDefaults',
		{
			message: 'Busy, please wait...',
			backdrop: true,
			templateUrl: 'Templates/Common/BusyOverlay.html',
			delay: 0,
			minDuration: 500,
			wrapperClass: 'cg-busy cg-busy-animation'
		})
		.config([
			'$provide',
			'$urlRouterProvider',
			'$urlMatcherFactoryProvider',
			'$locationProvider',
			'$stateProvider',
			'$httpProvider',
			'$cookiesProvider',
			'$logProvider',
			'$sessionStorageProvider',
			'$localStorageProvider',
			'uiMask.ConfigProvider',
			'AnalyticsProvider',
			($provide: angular.auto.IProvideService,
				$urlRouterProvider: angular.ui.IUrlRouterProvider,
				$urlMatcherFactoryProvider: angular.ui.IUrlMatcherFactory,
				$locationProvider: angular.ILocationProvider,
				$stateProvider: angular.ui.IStateProvider,
				$httpProvider: any,
				$cookiesProvider: any,
				$logProvider: angular.ILogProvider,
				$sessionStorageProvider: angular.storage.IStorageProvider,
				$localStorageProvider: angular.storage.IStorageProvider,
				uiMaskConfigProvider: any,
				analyticsProvider: angular.google.analytics.AnalyticsProvider) => {

                var badUrlHandler = ($injector: angular.auto.IInjectorService) => {
					var $state: any = $injector.get('$state');
					$state.go('NotFound', null, {
						location: false
					});
                };
                badUrlHandler.$inject = ['$injector'];

                $urlRouterProvider.otherwise(badUrlHandler);

				$urlMatcherFactoryProvider.strictMode(false);
				$urlMatcherFactoryProvider.caseInsensitive(true);

				$locationProvider.html5Mode(true);

				$sessionStorageProvider.setKeyPrefix('hilo-');
				$localStorageProvider.setKeyPrefix('hilo-');

				var defaults = $cookiesProvider.defaults as angular.cookies.ICookiesOptions;
				defaults.secure = window.location.protocol === 'https';
				defaults.domain = window['__appConfig'].cookieDomain;

				$logProvider.debugEnabled(window['__appConfig'].showDebugInfo);

				var googleAnalyticsTrackingId = window['__appConfig'].googleAnalyticsTrackingId;

				if (googleAnalyticsTrackingId) {
					analyticsProvider
						.setAccount(googleAnalyticsTrackingId)
						.setHybridMobileSupport(true)
						.logAllCalls(true)
						.trackPages(true)
						.setPageEvent('$stateChangeSuccess');

					if (window.location.hostname === 'localhost') {
						analyticsProvider.setDomainName('none');
					}
				}

				var decorator = ($delegate: any, $injector: angular.auto.IInjectorService) => (exception: any, cause: any) => {
					var errorHandler = $injector
						.get('app.common.services.errorHandlerService') as App.Common.Services.ErrorHandlerService;
					errorHandler.handleException(exception);
					$delegate(exception, cause);
				};
				decorator.$inject = ['$delegate', '$injector'];

				$provide.decorator('$exceptionHandler', decorator);

				uiMaskConfigProvider.clearOnBlur(false);

				var regexIso8601 =
					/^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,}))?(Z|([\-+])(\d{2}):(\d{2}))?)?)?)$/;

				function convertDateStringsToDates(input: Object) {
					if (typeof input !== 'object' || !input) {
						return input;
					}

					for (let key in input) {
						if (!input || !input.hasOwnProperty(key)) {
							continue;
						}
						var value: any = input[key];
						let match: RegExpMatchArray;
						//Check for string properties which look like dates
						if (typeof value === 'string' && (match = value.match(regexIso8601))) {
							const milliseconds = Date.parse(match[0]);
							if (!isNaN(milliseconds)) {
								input[key] = new Date(milliseconds);
							}
						} else if (typeof value === 'object') {
							convertDateStringsToDates(value); //Recurse into object
						}
					}
					return input;
				}

				//Enable automatic conversion of JSON date strings to JavaScript Date objects
				$httpProvider.defaults.transformResponse.push((responseData: any) => {
					convertDateStringsToDates(responseData);
					return responseData;
				});

			}
		]);

})());